import React from "react";

// Official Home Pro Connect logo (horizontal lockup). Hosted in /public.
// On dark surfaces (light=true) it sits in a white pill so the navy wordmark stays legible.
export const Logo = ({ light = false, className = "" }) => {
  const img = (
    <img
      src="/logo.webp"
      alt="Home Pro Connect"
      className="h-12 md:h-14 w-auto"
      draggable="false"
    />
  );
  return (
    <a
      href="/"
      data-testid="logo-link"
      className={`inline-flex items-center transition-transform duration-300 hover:-translate-y-0.5 ${className}`}
    >
      {light ? (
        <span className="inline-flex items-center rounded-xl bg-white px-3 py-2">{img}</span>
      ) : (
        img
      )}
    </a>
  );
};
